module.exports = __webpack_public_path__ + "static/media/add.16b1890f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/images/add.svg
 ** module id = 145
 ** module chunks = 0
 **/